"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplateStatus = void 0;
exports.getAssessmentTemplateStatuses = getAssessmentTemplateStatuses;
exports.getAssessmentTemplateStatusFrom = getAssessmentTemplateStatusFrom;
exports.getAllAssessmentTemplateStatus = getAllAssessmentTemplateStatus;
var AssessmentTemplateStatus;
(function (AssessmentTemplateStatus) {
    AssessmentTemplateStatus["Draft"] = "draft";
    AssessmentTemplateStatus["Published"] = "published";
    AssessmentTemplateStatus["All"] = "all";
    AssessmentTemplateStatus["Shared"] = "shared";
})(AssessmentTemplateStatus || (exports.AssessmentTemplateStatus = AssessmentTemplateStatus = {}));
function getAssessmentTemplateStatuses() {
    return Object.values(AssessmentTemplateStatus);
}
function getAssessmentTemplateStatusFrom(value) {
    return getAssessmentTemplateStatuses().find(function (status) { return status === value; });
}
function getAllAssessmentTemplateStatus(status) {
    return status === AssessmentTemplateStatus.All
        ? [AssessmentTemplateStatus.Draft, AssessmentTemplateStatus.Published]
        : status === AssessmentTemplateStatus.Shared
            ? [AssessmentTemplateStatus.Published]
            : [status];
}
